<!--The content below is only a placeholder and can be replaced.
<div style="text-align:center">
-->

<header></header>

<div>    
    <router-outlet></router-outlet>
</div>
<ngx-ui-loader fgsColor=gold fgsSize="120" fgsType="rectangle-bounce" [hasProgressBar]="false" fgsType="rectangle-bounce"></ngx-ui-loader>